import style from './arrow.module.scss'

export const Arrow = () => {
  return (
    <svg
      className={style.arrow}
      width="102"
      height="43"
      viewBox="0 0 102 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Arrow stem - curved line */}
      <path
        className={style.arrowStem}
        d="M0 41.5 Q30 42 73 22.3 Q88 15 100.5 2"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />
      {/* Arrow head - split into two lines from center */}
      <path
        className={style.arrowHeadTop}
        d="M100.5 2 L91.5 0.5"
        stroke="white"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        className={style.arrowHeadBottom}
        d="M100.5 2 L99.3 10.7"
        stroke="white"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  )
}
